/**
 * Banner Video Popup - PDP Mobile Short Banner
 * Handles open/close/pause for banner video popups
 */
class BannerVideoPopup {
  constructor(trigger) {
    this.trigger = trigger;
    this.popup = trigger.parentElement
      ? trigger.parentElement.querySelector('[data-banner-video-popup]')
      : null;

    if (!this.popup) return;

    this.video = this.popup.querySelector('video');
    this.closeBtn = this.popup.querySelector('[data-banner-video-close]');

    this.bindEvents();
  }

  bindEvents() {
    this.trigger.addEventListener('click', () => this.open());

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    this.popup.addEventListener('click', (e) => {
      if (e.target === this.popup) this.close();
    });
  }

  open() {
    this.popup.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (this.video) {
      this.video.currentTime = 0;
      this.video.play();
    }
  }

  close() {
    this.popup.classList.remove('active');
    document.body.style.overflow = '';
    if (this.video) this.video.pause();
  }

  static init() {
    var triggers = document.querySelectorAll('[data-banner-video-trigger]');
    if (!triggers || !triggers.length) return;
    triggers.forEach((trigger) => new BannerVideoPopup(trigger));
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => BannerVideoPopup.init());
} else {
  BannerVideoPopup.init();
}
